import _ from '@lodash';
import Typography from '@material-ui/core/Typography';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import FuseLoading from '@fuse/core/FuseLoading';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ListView from './listView';
import GridView from './gridView';


function EndUsersAccountsTable(props) {
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(props.endUsersAccounts.length);
	const [loading, setLoading] = useState(false);
	let endUsersAccountsMod = props.endUsersAccounts
		.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);


	// useEffect(()=>{
	// 	setRowsPerPage(props.endUsersAccounts.length);
	// },[props.endUsersAccounts])

	useEffect(()=>{
		setRowsPerPage(props.endUsersAccounts.length)
		setPage(0)
	},[props.endUsersAccounts.length])
	
	

	if(loading){
		return (<FuseLoading/>)
	}


	if (!props.viewPaymentTermPermission) {
		return (
			<div>
				<Card>
					<CardContent>You don't have permission to view any Payment Terms at this time. Please contact your Systems Administrator for access.</CardContent>
				</Card>
			</div>
		)
	}

	if(endUsersAccountsMod.length <= 0){
		return (
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1, transition: { delay: 0.1 } }}
				className="flex flex-1 items-center justify-center h-full"
			>
				<div style={{height: "200px"}}>
					<Typography variant="body2" component="p" color="textSecondary">
						No data found
					</Typography>
				</div>
			</motion.div>
		)
	}

	return (
		<div className="w-full flex flex-col">
			
			{/* <motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1, transition: { delay: 0.1 } }}
				className="flex flex-1 items-center justify-end h-full"
			>
				<Button
				color="primary"
					onClick={()=>props.openAddAttributeDialog(props.platformModuleId)}
				>
					Add field
				</Button>
			</motion.div> */}

			<SwitchView selectedView={props.selectedView} endUsersAccounts={endUsersAccountsMod} 
				refresh={props.refresh}
				viewPaymentTermPermission = { props.viewPaymentTermPermission }
				createPaymentTermPermission = { props.createPaymentTermPermission }
				updatePaymentTermPermission = { props.updatePaymentTermPermission }
				deletePaymentTermPermission = { props.deletePaymentTermPermission }	
			/>

			{/* <div className="p-10">
				<TablePagination
					className="flex-shrink-0 border-t-1 mt-10"
					component="div"
					count={props.endUsersAccounts.length}
					rowsPerPage={rowsPerPage !== props.endUsersAccounts.length ? rowsPerPage : 'all'}
					page={page}
					backIconButtonProps={{
						'aria-label': 'Previous Page'
					}}
					nextIconButtonProps={{
						'aria-label': 'Next Page'
					}}
					onChangePage={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			</div> */}

		</div>
	);

}

function SwitchView({
	endUsersAccounts, selectedView, refresh, viewPaymentTermPermission,
	createPaymentTermPermission, updatePaymentTermPermission, deletePaymentTermPermission
}) {
	if(selectedView === 0){
		return(
			<ListView 
				endUsersAccounts={endUsersAccounts}
				refresh={refresh}
				viewPaymentTermPermission = { viewPaymentTermPermission }
				createPaymentTermPermission = { createPaymentTermPermission }
				updatePaymentTermPermission = { updatePaymentTermPermission }
				deletePaymentTermPermission = { deletePaymentTermPermission } 
			/>)
	}else{
		return(<GridView endUsersAccounts={endUsersAccounts}
		/>)		
	}
}

export default withRouter(EndUsersAccountsTable)
